export default __webpack_public_path__ + "c265ba6cb05e124264f9ca21756e3bdd.mp3";